import React from 'react';
import { Skeleton } from '../Skeleton';
const QuizLoader = ({ type }) => {
  return (
    <>
      <div className="w-100 float-start quizCardV1Box shadow rounded-3 bg-white position-relative overflow-hidden">
        <span className="graph-1 position-absolute start-0 bottom-0"></span>
        <span className="graph-2 position-absolute start-0 bottom-0"></span>
        <div className="w-100 float-start quizCardV1BoxPic cursorPointer position-relative overflow-hidden">
          <Skeleton variant="rectangular" width="100%" height={200} className="object-fit-cover" />
        </div>
        <div className="w-100 float-start quizCrdV1Btm p-3  ps-0 ps-lg-0">
          <div className="crdV1topPart d-flex align-items-center justify-content-between position-relative mb-2 py-2 ps-4">
            <span className="crdV1topPartGraph position-absolute start-0 top-50 translate-middle-y"></span>
            <div className="text-black crdV1Speclty d-flex gap-2 align-items-center">
              <span className={`fs-4 cursorPointer gtm_cl_quizCard_specialities `}>
                <Skeleton variant="text" width={80} height={25} />
              </span>
            </div>
            <div className="quizCardV1TopRight d-inline-flex align-items-center">
              <Skeleton variant="text" width={30} height={25} />
            </div>
          </div>

          <div className="w-100 float-start d-flex text-start cardV1Topic mb-2 ps-4">
            <div className="cardV1TopicContent cursorPointer position-relative w-100">
              <h2 className={`text-black fs-16 fw-medium mb-2 gtm_cl_quizCard`}>
                <Skeleton variant="text" width="60%" height={30} />
              </h2>
              <p className={`text-dark fs-4 line-clamp-2 gtm_cl_quizCard`}>
                <Skeleton variant="text" width="90%" height={25} />
                <Skeleton variant="text" width="70%" height={25} />
              </p>
            </div>
          </div>

          <div className="w-100 float-start cardV1Ftr d-flex align-items-center justify-content-end ps-4 mt-2">
            <Skeleton variant="rounded" width={90} height={40} />
          </div>
        </div>
      </div>
    </>
  );
};

export default QuizLoader;
